export const CATEGORY_ICONS = {
  MARKETING: 'i-lucide-megaphone',
  UTILITY: 'i-lucide-bell',
  AUTHENTICATION: 'i-lucide-shield-check',
};
